import { OptimizelyExperiment, OptimizelyProviderWrapper } from './Optimizely';

export default OptimizelyExperiment;

export {
  OptimizelyProviderWrapper,
};
